import { useFloatingSelectContext } from '../../Floating'
import { ICON_HEIGHT_16 } from '../../Icon'
import { TextListItem } from '../../ListItem'
import { MultiValuedListMoreItem } from '../../MultiValuedList'
import { getTaskIconByApiName } from '../Task.utils'

import * as styles from './TaskTypeListMoreItem.module.css'

function TaskTypeListMoreItem({
  activeItem,
  className = styles.TaskTypeListMoreItem,
  disabled,
  enabled,
  icon,
  id,
  name,
  onClick,
  ...itemProps
}) {
  const type = { enabled, icon, id, name }

  const { context } = useFloatingSelectContext()

  function handleClick() {
    if (!disabled) {
      context.setOpen(false)

      onClick?.({ icon: type.icon, id: type.id, name: type.name })
    }
  }

  return (
    <MultiValuedListMoreItem
      {...itemProps}
      className={className}
      disabled={disabled}
    >
      <TextListItem
        showTooltip
        ListIcon={getTaskIconByApiName(type.icon.name)}
        avatarProps={{ iconSize: ICON_HEIGHT_16 }}
        className={styles.listItem}
        isActive={activeItem?.id === type.id}
        text={type.name}
        value={type.id}
        onClick={handleClick}
      />
    </MultiValuedListMoreItem>
  )
}

export default TaskTypeListMoreItem
